(function (appComponents) {

	appComponents.controllers.searchResults = function (Components) {

		var searchResults = {};

		searchResults.name = "searchResults";
		searchResults.currentFilters = {};

		Components.getControllerPrototype().extend(searchResults);

		searchResults._b2bUnit = searchResults._getService("b2bUnit");
		searchResults._product = searchResults._getService("productBase");
		searchResults._cart = searchResults._getService("cartBase");
		searchResults._panda = searchResults._getService("panda");
		searchResults._modals = searchResults._getService("modals");
		searchResults._helpers = searchResults._getService("helpers");

		searchResults.pager = searchResults._helpers.getPager(searchResults);

		searchResults.itemCollection = searchResults._getPageComponent("searchItemsCollection");

		searchResults.opts = {
			numToDisplay: 10
		};

		searchResults.context.pagerData = searchResults.pager.data;
		
		searchResults.b2bUnitOnLoad = function () {
			var categoryCode = searchResults._queryData.categoryCode;
			if(categoryCode == null || categoryCode == undefined){
				var unitType = searchResults._b2bUnit.unitType;
				if (unitType == "SAP") {
					searchResults.elements.systemComponents.show();
					searchResults.elements.advancedSearchTopBar.hide();
					searchResults.elements.priceAndAvail.hide();
					if(searchResults.elements.filterByTypeSelectorPcPartsOption != undefined && searchResults.elements.filterByTypeSelectorPcPartsOption.length == 0){
						searchResults.elements.filterByTypeSelector.append($('<option>',
								 {
								    value: "pc-parts",
								    text : "System Components"
								}));
					}
					searchResults.elements.filterByTypeSelector.find('option:selected').removeAttr('selected');
					searchResults.elements.filterByTypeSelectorPcPartsOption.prop('selected',true);
					searchResults.elements.filterByTypeSelector.trigger("change");
					searchResults.elements.filterByTypeSelector.attr("disabled",true);
				} else if (unitType == "ORACLE"){
					searchResults.elements.systemComponents.hide();
					searchResults.elements.advancedSearchTopBar.show();
					searchResults.elements.priceAndAvail.show();
					searchResults.elements.filterByTypeSelector.attr("disabled",false);
					searchResults.elements.filterByTypeSelectorPcPartsOption.remove();
					searchResults.elements.filterByTypeSelector.find('option:selected').removeAttr('selected');
					searchResults.elements.filterByTypeSelectorGeneralSearchOption.prop('selected',true);
					searchResults.elements.filterByTypeSelector.trigger("change");
				}
			}
		};

		searchResults.elements = {
			get results() {
				return $("[pc-container='search-results--results']");
			},
			get filterSelectors() {
				return $("[pc-container='search-results--filters-current']");
			},
			get searchQueryString() {
				return $("[pc-container='search-results--search-by-text']");
			},
			get filtersContainer() {
				return $(".pc-filters-container");
			},
			get lvFiltersContainer() {
				return $('[pc-container="search-results--lv-filters-container"]');
			},
			get filterByKeywordInput() {
				return $('[pc-container="search-results--filter-by-keyword-input"]');
			},
			//Added
			get filterByGoCodeFilter() {
				return $('[pc-container="search-results--filters-gocode-type-selector"]:visible');
			},
			get filterByTypeSelector() {
				return $('[pc-container="search-results--filters-current-type-selector"]');
			},
			get filtersLvMotorsForm() {
				return $('[pc-container="search-results--filters-lv-motors-form"]');
			},
			get filtersPcPartsForm() {
				return $("[pc-container='search-results--filters-pc-parts-form']");
			},
			get filtersPartsPlusForm() {
				return $("[pc-container='search-results--filters-parts-plus-form']");
			},
			get filtersCompCatForm() {
				return $("[pc-container='search-results--filters-competitive-catalog-form']");
			},
			get filtersGeneralSearchForm() {
				return $("[pc-container='search-results--filters-general-search-form']");
			},
			get filterByTypeSelectorPcPartsOption(){
				return $('[pc-container="search-results--filters-current-type-selector"] option[value="pc-parts"]');
			},
			get filterByTypeSelectorGeneralSearchOption(){
				return $('[pc-container="search-results--filters-current-type-selector"] option[value="general-search"]');
			},
			get advancedSearchTopBar() {
				return $('.adv-searchicon');
			},
			get systemComponents() {
				return $('[pc-container="system--components--li"]');
			},
			get advancedSearchHomeBar(){
				return $('.dis-inline-table');
			},
			get priceAndAvail() {
				return $('[pc-container="search-results--batch-get-panda"]');
			},
			get sortBySelector(){
				return $('[pc-container="search-results--sortby-selector"]');
			}
		};

		searchResults.bindings = function () {


			searchResults._elements.page.on("click", ".accordian-heading", function () {
				$(this).find('.fa').toggleClass('fa-plus fa-minus');
			});

			searchResults._elements.page.on("click", "[pc-container='search-results--item-title']", function () {
				var code = $(this).parent().closest('[pc-container="search-results--item"]').attr("pc-value");
				searchResults.handlers.onProductTitleClick(code);
			});

			searchResults._elements.page.on("click", "[pc-container='search-results--filters-apply-btn']", function () {

				searchResults.handlers.onFiltersFormSubmit();
			});
			//Added
			searchResults._elements.page.on("change", ".go-code-filters", function () {
				searchResults.handlers.onFiltersFormSubmit();
			});

			searchResults._elements.page.on("keypress", "[pc-container='search-results--filter-by-keyword-input']", function (e) {
				var key = e.which;
				if (key == 13) {
					searchResults.handlers.onFiltersFormSubmit();
				}
			});

			searchResults._elements.page.on("click", "[pc-container='search-results--reset-filters-btn']", function () {

				searchResults.handlers.onFiltersFormReset();
			});

			searchResults._elements.page.on("click", "[pc-container='search-results--item-send-feedback']", function () {
				var code = $(this).parent().closest('[pc-container="search-results--item"]').attr("pc-value");
				var combinedKitCode = $(this).closest('[pc-container="search-results--item"]').attr("pc-combined-kit-code");


				searchResults.handlers.onSendFeedback(code, combinedKitCode);
			});

			searchResults._elements.page.on("click", "[pc-container='search-results--item-panda-details']", function () {
				var code = $(this).parent().closest('[pc-container="search-results--item"]').attr("pc-value");
				var combinedKitCode = $(this).closest('[pc-container="search-results--item"]').attr("pc-combined-kit-code");

				searchResults.handlers.onPandaDetails(code, combinedKitCode);
			});

			searchResults._elements.page.on("click", "[pc-container='search-results--item-datapack']", function () {
				var code = $(this).parent().closest('[pc-container="search-results--item"]').attr("pc-value");
				var type = $(this).attr("pc-value");
				searchResults.handlers.onDataPackItemClick(code, type);
			});

			/*searchResults._elements.page.on("blur", '[pc-container="search-results--item-spa-field"]', function () {
				var code = $(this).closest('[pc-container="search-results--item"]').attr("pc-value");
				searchResults.handlers.onCheckPanda(code);
			});*/
           
            searchResults._elements.page.on("click", '[pc-container="search-results--item-spa-button"]', function () {
				var code = $(this).closest('[pc-container="search-results--item"]').attr("pc-value");
				searchResults.handlers.onCheckPanda(code);
			});
			
			searchResults._elements.page.on("change", '[pc-container="search-results--item-spa-selector"]', function () {
				var val = this.value;
				if (val == "not-listed") return;

				var code = $(this).closest('[pc-container="search-results--item"]').attr("pc-value");
				searchResults.handlers.onCheckPanda(code);
			});

			searchResults._elements.page.on("click", '[pc-container="search-results--item-get-panda"]', function () {
				var code = $(this).closest('[pc-container="search-results--item"]').attr("pc-value");
				var combinedKitCode = $(this).closest('[pc-container="search-results--item"]').attr("pc-combined-kit-code");

				searchResults.handlers.onCheckPanda(code, combinedKitCode);
			});


			searchResults._elements.page.on("click", '[pc-container="search-results--item-add-to-cart"]', function () {
				var code = $(this).closest('[pc-container="search-results--item"]').attr("pc-value");
				var combinedKitCode = $(this).closest('[pc-container="search-results--item"]').attr("pc-combined-kit-code");

				searchResults.handlers.addToCartItem(code, combinedKitCode);
			});

			searchResults._elements.page.on("click", '[pc-container="search-results--batch-get-panda"]', function () {

				searchResults.handlers.onCheckPandaBatch();
			});

			searchResults._elements.page.on("click", '[pc-container="search-results--batch-add-to-cart"]', function () {

				searchResults.handlers.onAddToCartBatch();
			});

			searchResults._elements.page.on('ifChecked', '[pc-container="search-results--lv-filters-type"]', function () {
				searchResults._applyScript.base.select2('close');
				var lvFilterType = this.value;
				searchResults.renderLvFilters(lvFilterType);
			});

			searchResults._elements.page.on("change", '.price-select', function () {
				var value = $(this).val();
				if (value == "not-listed") {
					$(this).closest('.power-electronic-list li').find('.spa-not-listed').show();
				} else {
					$(this).closest('.power-electronic-list li').find('.spa-not-listed').hide();
				}
			});

			searchResults._elements.page.on("change", ".sortby-param", function () {
				searchResults.handlers.onSortByChange();
			});
			
		};

		searchResults.liveBindings = function () {
			$('.aside-lv-pc').change(function () {
				var value = $(this).val();
				if (value == "lv-motors") {
					$('.pc-filters-container').removeClass('dis-none');
					$('.ac-panel').removeClass('dis-none');
					$('.dc-panel').removeClass('dis-none');
					$('.pc-panel').addClass('dis-none');
					$('#browseCatalogFilterDiv').removeClass('dis-none');
					$('#consolidatedFilterSelectId').trigger("change");
				}
				if (value == "pc-parts") {
					$('.pc-filters-container').removeClass('dis-none');
					$('.ac-panel').addClass('dis-none');
					$('.dc-panel').addClass('dis-none');
					$('.pc-panel').removeClass('dis-none');
					$('#browseCatalogFilterDiv').addClass('dis-none');
				}
				if (value == "general-search" || value == "competitive-catalog" || value == "parts-plus") {
					$('.pc-filters-container').addClass('dis-none');
					$('#browseCatalogFilterDiv').addClass('dis-none');
				}
				if (value == "general-search" || value == "competitive-catalog" || value == "parts-plus" || value == "pc-parts") {
					$('.pc-filters-category').addClass('dis-none');
				} 
			});
			//Added
			$('#consolidatedFilterSelectId').change(function () {
				var conslFiltre = $(this).val();
				$('.go-code-filters').each(function(){
				var parent = $(this).attr('id');
				if(conslFiltre == parent)
					{
						$(this).parent().removeClass('dis-none');
					}
				else{
					$(this).parent().addClass('dis-none');
				}
				});	
				searchResults.handlers.onFiltersFormSubmit();
			});
			
			
			//search-results--lv-filters-type panel
			$( ".bg-white-cont" ).mouseleave(function() {
				var panel = $('[pc-container="search-results--sticky-panel"]'); 
				 //panel.css("top","0px");
				panel.css({'top' : '0px',
				  'webkit-transition' : 'all .5s ease-in-out',
				    '-moz-transition' : 'all .5s ease-in-out',
				    '-o-transition' : 'all .5s ease-in-out',
				    'transition' : 'all .5s ease-in-out'
				});
				  panel.removeAttr("pc-sticky");
				  panel.removeAttr("pc-sticky-aux-value-to-offset");
				});
				$( ".bg-white-cont" ).mouseenter(function() {
				var panel = $('[pc-container="search-results--sticky-panel"]'); 
				panel.removeAttr("style");
				  panel.attr({ 'pc-sticky' : '', 
				     'pc-sticky-aux-value-to-offset' : '89'});
				});

           
		};

		searchResults.renderLvFilters = function (lvFilterType) {
			searchResults.context.currentLvFilters = searchResults.context.lvFilters[lvFilterType];
			searchResults._renderTemplate("lvFiltersContainer", null, true);
			searchResults._applyScript.base.select2();
		};

		searchResults.populateInitialContext = function () {
			searchResults.context.lvFilters = {};
			console.log("searchResults._queryData",searchResults._queryData);
			searchResults.context.isInventoryPage = searchResults._queryData.isInventoryPage;
			
			var defLvAll = searchResults._api.searchResults.getLvMotorsFilterOptions("").then(function (res) {
				if (res) {
					searchResults.context.lvFilters.motors = res.body;
					return true;
				}
			});

			var defLvAc = searchResults._api.searchResults.getLvMotorsFilterOptions("AC").then(function (res) {
				if (res) {
					searchResults.context.lvFilters.ac = res.body;
					return true;
				}
			});

			var defLvDc = searchResults._api.searchResults.getLvMotorsFilterOptions("DC").then(function (res) {
				if (res) {
					searchResults.context.lvFilters.dc = res.body;
					return true;
				}
			});

			var defPc = searchResults._api.searchResults.getPcPartsFilterOptions().then(function (res) {
				if (res && res.status == 200) {
					searchResults.context.pcPartsOptions = res.body;
					return true;
				}
			});
			
			searchResults._api.searchResults.getSubCategoriesForCode("rmcategory_BrowseCatalog").then(function(res){
			    searchResults.context.consolidatedFiltersLV = res.body;
				});
			
			return $.when(defLvAll, defLvAc, defLvDc, defPc);
		};

		searchResults.prepareSearchData = function () {

			var searchData = searchResults._queryData;
			/*var sortBy = searchResults.elements.sortBySelector.val();
			if(sortBy != undefined && sortBy != null)
			{
				searchData.sortBy = sortBy;
			}*/
			searchData.customerIndexType = searchResults._b2bUnit.unitType;
			if (!searchData.resultsPerPage) {
				searchData.pageNumber = 1;
				searchData.resultsPerPage = searchResults.opts.numToDisplay;
			}

			return searchData;

		};

		searchResults.generateSubCategoryAndSearchQueryString = function (searchData) {
			var subCatTitle = "";
			var searchQueryString = "";
			switch (searchData.searchBy) {
				case "parts":
					subCatTitle = "PC Parts";
					break;
				case "partsplus":
					subCatTitle = "LV Motor Parts +";
					break;
				case "ac":
				case "dc":
				case "motors":
					subCatTitle = "LV Motors";
					break;
				case "compcatalog":
					subCatTitle = "Competitive catalog";
					break;
				default:
					subCatTitle = "All Products";
					break;
			}

			if (searchData.search) {
				searchQueryString = subCatTitle + " containing '" + searchData.search + "'";
			} else {
				searchQueryString = subCatTitle;
			}

			searchResults.context.subCategoryTitle = subCatTitle;
			searchResults.context.gridGuest = false;
			if(searchData.value == "grid"){
				searchResults.context.gridGuest = true;
			}
			if(searchResults._config.user.isGridUser || searchData.value == "grid"){
				searchResults.context.subCategoryTitle = "GS Parts";
			}
			searchResults.context.searchQueryString = searchQueryString;

		};

		searchResults.parseSearchResponse = function (res, searchData) {
			var motorTypes = ["ac", "dc", "motors"];
			var generalSearchTypes = ["catalog", ""];
			var searchBy = searchData.searchBy.toLowerCase();

			searchResults.context.flags.isGeneralSearch = (generalSearchTypes.indexOf(searchBy) > -1);
			searchResults.context.flags.isMotorsSearch = (motorTypes.indexOf(searchBy) > -1);
			searchResults.context.flags.isPartsSearch = (searchBy == "parts");
			searchResults.context.flags.isPartsPlusSearch = (searchBy == "partsplus");
			searchResults.context.flags.isCompCatSearch = (searchBy == "compcatalog");
			searchResults.context.flags.isTypeLocked = (searchData.isTypeLocked);
			

			if (searchResults.context.flags.isMotorsSearch) {
				searchResults.context.currentLvFilters = searchResults.context.lvFilters[searchBy];
			} else {
				searchResults.context.currentLvFilters = searchResults.context.lvFilters.motors;
			}

			searchResults.context.searchData = searchData;
			searchResults.generateSubCategoryAndSearchQueryString(searchData);
			searchResults.context.goCodeSelectedVal = res.body.goCodeFilter;
			searchResults.context.consolidatedFilterSelectedVal = res.body.consolidatedFilter;

			if (res && res.status == 200) {
				
				searchResults.context.flags.noResults = false;
				searchResults.context.products = res.body.searchPageData.results;
				
				searchResults.context.kits = res.body.kitsAndAccessoriesMap;
				searchResults.context.refs = res.body.prodRefData;
				
				
				searchResults.pager.data = res.body.searchPageData.pagination;
				searchResults.context.pagerData = searchResults.pager.data;
				


			} else {
				searchResults.context.products = "";
				searchResults.context.flags.noResults = true;
				searchResults._modals.loading.hide(); 

			}
		};

		searchResults.searchByQueryWithPager = function () {

			var searchData = searchResults.prepareSearchData();

			return searchResults._api.searchResults.search(searchData).then(function (res) {
				searchResults.parseSearchResponse(res, searchData);
			}).fail(function (e) {
				searchResults._modals.loading.hide();
				console.log("--- Fail ---",e);
			});
		};

		searchResults.renderResults = function () {
		
			var html = searchResults.templates.resultsHolder(searchResults.context);
			searchResults.elements.results.html(html);
			searchResults.updatePager();
			searchResults.elements.searchQueryString.text(searchResults.context.searchQueryString);

			searchResults._applyScript.iCheck();
			searchResults._applyScript.niceScroll();
			searchResults._applyScript.base.select2();

			
		};
		
		searchResults.updatePager = function () {
			var totalLength = searchResults.context.products.length;
			if(totalLength > 0){
				$(".results-inventory-report").show();
			}else{
				$(".results-inventory-report").hide();
			}	
		};
		
		searchResults.updateConsolidatedFilters = function () {
			
			//Update filters after page is loaded, via ajax
			var conslFiltre = searchResults.context.consolidatedFilterSelectedVal;
			$('.go-code-filters').each(function(){
			var parent = $(this).attr('id');
			if(conslFiltre == parent)
				{
					$(this).parent().removeClass('dis-none');
				}
			else{
				$(this).parent().addClass('dis-none');
			}
			});	

			
		};

		searchResults.searchRoutine = function () {
			searchResults.searchByQueryWithPager().then(function () {
				searchResults.renderResults();
				searchResults.itemCollection.setCollection(searchResults.context.products, searchResults.context.kits);
				
				if((!searchResults.context.flags.isGuest || searchResults.context.flags.isGuest === undefined) && !searchResults.context.flags.isPartsSearch && searchResults.context.products.length > 0){
					 searchResults._modals.loading.show(); 
					 var totalLength = searchResults.context.products.length;
					
	 					for (var property in searchResults.context.products) { 
	 						
			            	  var code = searchResults.context.products[property].code;
			            	  var combinedKitCode;
			              
                             searchResults.handlers.onCheckPandaNew(code, combinedKitCode, totalLength);
			            	  
			              }

	 					//searchResults._modals.loading.hide();	

				}

			
			});
		};


		searchResults.handlers = {
			onFiltersFormReset: function () {
				searchResults.elements.filterByKeywordInput.val("");

				searchResults.elements.filtersLvMotorsForm.find('input[value="motors"]').iCheck('check');
				searchResults.elements.filtersLvMotorsForm.find('select').val('').trigger("change");
				searchResults.elements.filtersLvMotorsForm.find('input:visible').not("input[type='radio']").val('');

				searchResults.elements.filtersPcPartsForm.trigger("reset").find("input:checkbox").removeAttr("checked").iCheck("update");
				searchResults.context.searchData = {};

				searchResults.handlers.onFiltersFormSubmit();
			},
			onFiltersFormSubmit: function () {
				var type = searchResults.elements.filterByTypeSelector.val();
				var formElement = null;
				var checkKeywordField = false;

				switch (type) {
					case "lv-motors":
						formElement = searchResults.elements.filtersLvMotorsForm;
						break;
					case "pc-parts":
						formElement = searchResults.elements.filtersPcPartsForm;
						break;
					case "parts-plus":
						formElement = searchResults.elements.filtersPartsPlusForm;
						break;
					case "general-search":
						formElement = searchResults.elements.filtersGeneralSearchForm;
						break;
					case "competitive-catalog":
						formElement = searchResults.elements.filtersCompCatForm;
						checkKeywordField = true;
						break;
				}

				var formData = searchResults._utils.getFormData(formElement, true);
				formData = searchResults._utils.removeEmptyProps(formData);

				searchResults.pager.reset();

				var pagerData = {
					pageNumber: searchResults.pager.pageToSet,
					resultsPerPage: searchResults.pager.pageSize
				};

				var queryData = jQuery.extend({}, formData, pagerData);

				queryData.search = searchResults.elements.filterByKeywordInput.val();
				//Added
				queryData.categoryCode = searchResults.elements.filterByGoCodeFilter.val();

				if (checkKeywordField && !queryData.search) {
					searchResults._modals.warning.show(searchResults._messages.search.noCompCatValue);
					return;
				}

				searchResults._updateUrlQuery("push", queryData);

				searchResults.searchRoutine();
			},
			onProductTitleClick: function (code) {
				searchResults.itemCollection.findItemByCode(code).showProductDetails();
			},
			onDataPackItemClick: function (code, type) {
				searchResults.itemCollection.findItemByCode(code).downloadDataPack(type);
			},
			addToCartItem: function (code, combinedKitCode) {
				var access = searchResults._b2bUnit.checkB2BUnit();
				if (!access) {
					searchResults._modals.warning.show(searchResults._messages.noB2bUnitSelected);
					return;
				}
				searchResults.itemCollection.findItemByCode(code, combinedKitCode).addToCart();

			},
			onAddToCartBatch: function () {
				if (searchResults.itemCollection.isAtLeastOneSet) {
					searchResults._modals.warning.show(searchResults._messages.noItemsChecked);
					return;
				}

				var access = searchResults._b2bUnit.checkB2BUnit();
				if (!access) {
					searchResults._modals.warning.show(searchResults._messages.noB2bUnitSelected);
					return;
				}
				searchResults.itemCollection.addToCartBatch();
			},
			onCheckPandaBatch: function () {
				if (searchResults.itemCollection.isAtLeastOneSet) {
					searchResults._modals.warning.show(searchResults._messages.noItemsChecked);
					return;
				}
				var access = searchResults._b2bUnit.checkB2BUnit();
				if (!access) {
					searchResults._modals.warning.show(searchResults._messages.noB2bUnitSelected);
					return;
				}
				searchResults.itemCollection.checkPandaBatch();
			},
			onCheckPanda: function (code, combinedKitCode) {
				var access = searchResults._b2bUnit.checkB2BUnit();
				if (!access) {
					searchResults._modals.warning.show(searchResults._messages.noB2bUnitSelected);
					return;
				}
				searchResults.itemCollection.findItemByCode(code, combinedKitCode).checkPanda();
			},
			onCheckPandaNew: function (code, combinedKitCode, totalLength, count) {
				var access = searchResults._b2bUnit.checkB2BUnit();
				if (!access) {
					searchResults._modals.warning.show(searchResults._messages.noB2bUnitSelected);
					return;
				}
				searchResults.itemCollection.findItemByCode(code, combinedKitCode).checkPandaNew(totalLength);
			},
			onSendFeedback: function (code, combinedKitCode) {
				searchResults.itemCollection.findItemByCode(code, combinedKitCode).sendReplFeedback();

			},
			onPandaDetails: function (code, combinedKitCode) {
				searchResults.itemCollection.findItemByCode(code, combinedKitCode).showPandaDetails();
			},
			onB2bUnitChanged: function () {
				if (searchResults._isActiveController) {
					searchResults.searchRoutine();
				}
			},
			pager: {
				onPagerClick: function () {
					searchResults._updateUrlQueryWithPagerData("push");
					searchResults.searchRoutine();
				}
			},
			onSortByChange: function () {
				
				var searchData = searchResults._queryData;
				var sortBy = searchResults.elements.sortBySelector.val();
				if(sortBy != undefined && sortBy != null)
				{
					searchData.sortBy = sortBy;
				}
				
				searchResults.pager.reset();
				var pagerData = {
					pageNumber: searchResults.pager.pageToSet,
					resultsPerPage: searchResults.pager.pageSize
				};
				
				var queryData = jQuery.extend({}, searchData, pagerData);
				
				searchResults._updateUrlQuery("push", queryData);
				searchResults.searchRoutine();
			},
			getPriceAndAvailability: function (combinedKitCode, totalLength, count) {
				var access = searchResults._b2bUnit.checkB2BUnit();
				if (!access) {
					searchResults._modals.warning.show(searchResults._messages.noB2bUnitSelected);
					return;
				}
				var items = searchResults.itemCollection.getItemsForCodes(combinedKitCode, count);
				searchResults.itemCollection.getPriceAvailability(items, totalLength);
			}
		};

		searchResults.init = function () {

			searchResults.populateInitialContext().then(function () {

				searchResults.searchByQueryWithPager().then(function () {

					searchResults._renderPageTemplate();

					searchResults.renderResults();

					searchResults._scrollToTop();

					try{
					searchResults.itemCollection.setCollection(searchResults.context.products, searchResults.context.kits);
					}catch(e){
						console.log(e);
					}
					searchResults._bindings();

					searchResults.pager.init();

					searchResults._events.registerHandler("b2bUnitChanged", searchResults.name, searchResults.handlers.onB2bUnitChanged);

					searchResults._events.dispatchEvent("controllerInitialized");
					
					searchResults.updateConsolidatedFilters();
					
					searchResults.b2bUnitOnLoad();
					
					$.urlParam = function (name) {
						var results = new RegExp('[\?&]' + name + '=([^&#]*)')
										  .exec(window.location.href);
						if (results == null) {
							 return 0;
						}
						return results[1] || 0;
					};
					
					var isInventoryPage = $.urlParam('isInventoryPage');

					var promise = [];
					if((!searchResults.context.flags.isGuest || searchResults.context.flags.isGuest === undefined) && !searchResults.context.flags.isPartsSearch && searchResults.context.products.length > 0){
						 searchResults._modals.loading.show(); //show loading for search-results
						 var totalLength = searchResults.context.products.length;
						var count = 0;
						//init search results on load
						   if(isInventoryPage)
							{
								var combinedKitCode = [];
								var code;
								for (var property in searchResults.context.products) { 
									code = searchResults.context.products[property].code;
									combinedKitCode.push(code);
									count= count +1;
								 }
								searchResults.handlers.getPriceAndAvailability(combinedKitCode, totalLength, count);
							}
							else
							{
								for (var property in searchResults.context.products) { 
		 						
				            	  var code = searchResults.context.products[property].code;
				            	  var combinedKitCode;
				                  count= count +1;
                                  searchResults.handlers.onCheckPandaNew(code, combinedKitCode, totalLength);
				            	  
				              }
							}
		 					//searchResults._modals.loading.hide();
					  }
									
				});

			}).fail(function (e) {
				console.log(e);
			});

		};
		 searchResults._modals.loading.hide();
		 
		return searchResults;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});